import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { get as getProjection } from 'ol/proj';

export default function useMapProjection() {
  proj4.defs(
    'EPSG:27700',
    '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs',
  );

  register(proj4);

  const proj27700 = getProjection('EPSG:27700');

  if (proj27700 !== null) {
    proj27700.setExtent([-650000, -150000, 1350000, 1450000]);
  }

  return proj27700;
}
